// extracted by mini-css-extract-plugin
module.exports = {"tr":"TableBody_tr_1VvXG","td":"TableBody_td_2sJ5_","checkboxColumn":"TableBody_checkboxColumn_2cHIi"};